import apiFetch from '../apiFetch'

export default function (token, dossierId, dossierNumber, documents) {
  return apiFetch({ endPoint: `Document/${dossierId}/PutDocumentsToSign/${dossierNumber}`, method: 'PUT', token: token, body: documents })
}
